"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3673],{

/***/ 3673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Navbar_SearchSidebar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.mjs
var io = __webpack_require__(4920);
;// CONCATENATED MODULE: ./hooks/useDebounce.js


function useDebounce(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var _useState = (0,react.useState)(value),
      debounced = _useState[0],
      setDebounced = _useState[1];

  (0,react.useEffect)(function () {
    var handler = setTimeout(function () {
      return setDebounced(value);
    }, delay); // eslint-disable-next-line no-undef

    return function () {
      return clearTimeout(handler);
    };
  }, [value, delay]);
  return debounced;
}

/* harmony default export */ var hooks_useDebounce = (useDebounce);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(5602);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(950);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(1766);
// EXTERNAL MODULE: ./services/helper.js + 180 modules
var helper = __webpack_require__(7925);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(1401);
;// CONCATENATED MODULE: ./hooks/useSearchProducts.js






function useSearchProducts(storeId, collectionId, searchQuery) {
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var abortControllerRef = (0,react.useRef)(null);

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      data: state.data,
      setData: state.setData,
      scrollPosition: state.scrollPosition,
      setScrollPosition: state.setScrollPosition
    };
  }),
      zustandData = _useStore.data,
      setData = _useStore.setData,
      scrollPosition = _useStore.scrollPosition,
      setScrollPosition = _useStore.setScrollPosition;

  var fetchProducts = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
      var _ref$pageParam, pageParam, signal, url, res, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$pageParam = _ref.pageParam, pageParam = _ref$pageParam === void 0 ? 0 : _ref$pageParam, signal = _ref.signal;
              url = "".concat(helper/* publicServerEndpoint */.v2, "/v3/product/store/").concat(storeId, "/collectionv2?page=").concat(pageParam, "&limit=", 20, "&source=web");

              if (collectionId && collectionId !== "all") {
                url += "&collectionId=".concat(collectionId);
              }

              if (searchQuery) {
                url += "&search=".concat(searchQuery);
              }

              _context.next = 6;
              return fetch(url, {
                signal: signal
              });

            case 6:
              res = _context.sent;

              if (res.ok) {
                _context.next = 9;
                break;
              }

              throw new Error("Failed to fetch");

            case 9:
              _context.next = 11;
              return res.json();

            case 11:
              data = _context.sent;
              return _context.abrupt("return", {
                products: data.data.docs,
                nextPage: pageParam + 1,
                previousPage: pageParam > 1 ? pageParam - 1 : null,
                hasNextPage: data.data.hasNextPage
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProducts(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useInfiniteQuery = (0,useInfiniteQuery/* useInfiniteQuery */.N)({
    queryKey: ["products", storeId, collectionId, searchQuery],
    queryFn: fetchProducts,
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage !== null && lastPage !== void 0 && lastPage.hasNextPage ? lastPage.nextPage : undefined;
    },
    enabled: !!storeId && searchQuery.length > 2,
    initialData: zustandData
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isFetchingNextPage = _useInfiniteQuery.isFetchingNextPage,
      hasNextPage = _useInfiniteQuery.hasNextPage,
      isLoading = _useInfiniteQuery.isLoading,
      error = _useInfiniteQuery.error,
      refetch = _useInfiniteQuery.refetch,
      isFetching = _useInfiniteQuery.isFetching;

  (0,react.useEffect)(function () {
    if (data) {
      setData(data);
    }
  }, [data, searchQuery, setData]);

  var onSearch = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var controller;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (abortControllerRef.current) {
                abortControllerRef.current.abort();
              } // eslint-disable-next-line no-undef


              controller = new AbortController();
              abortControllerRef.current = controller;
              _context2.prev = 3;
              queryClient.removeQueries(["products", storeId, collectionId]);
              refetch();
              _context2.next = 15;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](3);

              if (!(_context2.t0.name === "AbortError")) {
                _context2.next = 14;
                break;
              }

              console.log("Request aborted");
              _context2.next = 15;
              break;

            case 14:
              throw _context2.t0;

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 8]]);
    }));

    return function onSearch() {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    data: data,
    fetchNextPage: fetchNextPage,
    isFetchingNextPage: isFetchingNextPage,
    hasNextPage: hasNextPage,
    isLoading: isLoading,
    error: error,
    onSearch: onSearch,
    isFetching: isFetching,
    setScrollPosition: setScrollPosition,
    scrollPosition: scrollPosition
  };
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(5827);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(131);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(7756);
// EXTERNAL MODULE: ./pages/500.js
var _500 = __webpack_require__(7486);
// EXTERNAL MODULE: ./components/EmptyStore.jsx + 1 modules
var EmptyStore = __webpack_require__(8272);
// EXTERNAL MODULE: ./components/Home/RestorableList.jsx
var RestorableList = __webpack_require__(7861);
// EXTERNAL MODULE: ./components/SkeletonCard.jsx
var SkeletonCard = __webpack_require__(3101);
// EXTERNAL MODULE: ./components/StoreItem.jsx + 1 modules
var StoreItem = __webpack_require__(2141);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/ProductListing/index.jsx












var ProductListing = function ProductListing(_ref) {
  var _productData$pages;

  var store = _ref.store,
      _ref$wrapperClassName = _ref.wrapperClassName,
      wrapperClassName = _ref$wrapperClassName === void 0 ? "" : _ref$wrapperClassName,
      _ref$useVirtualizer = _ref.useVirtualizer,
      useVirtualizer = _ref$useVirtualizer === void 0 ? false : _ref$useVirtualizer,
      storeProductsQueryProps = _ref.storeProductsQueryProps,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search,
      _ref$searchQuery = _ref.searchQuery,
      searchQuery = _ref$searchQuery === void 0 ? "" : _ref$searchQuery,
      _ref$toggleDrawer = _ref.toggleDrawer,
      toggleDrawer = _ref$toggleDrawer === void 0 ? function () {} : _ref$toggleDrawer,
      _ref$setScrollPositio = _ref.setScrollPosition,
      setScrollPosition = _ref$setScrollPositio === void 0 ? function () {} : _ref$setScrollPositio,
      _ref$scrollPosition = _ref.scrollPosition,
      scrollPosition = _ref$scrollPosition === void 0 ? 0 : _ref$scrollPosition;

  var _useState = (0,react.useState)(null),
      lastEl = _useState[0],
      setLastEl = _useState[1];

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var scrollRef = (0,react.useRef)(null);
  var productData = storeProductsQueryProps.data,
      isProductsLoading = storeProductsQueryProps.isLoading,
      isFetchingNextPage = storeProductsQueryProps.isFetchingNextPage,
      fetchNextPage = storeProductsQueryProps.fetchNextPage,
      hasNextPage = storeProductsQueryProps.hasNextPage,
      productError = storeProductsQueryProps.error; // eslint-disable-next-line react-hooks/exhaustive-deps

  var products = (productData === null || productData === void 0 ? void 0 : (_productData$pages = productData.pages) === null || _productData$pages === void 0 ? void 0 : _productData$pages.flatMap(function (page) {
    return page.products;
  })) || [];
  (0,react.useEffect)(function () {
    var timer;

    if (inView && hasNextPage && !isFetchingNextPage) {
      timer = setTimeout(function () {
        fetchNextPage();
      }, 100);
    }

    return function () {
      window.clearTimeout(timer);
    };
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);
  (0,react.useEffect)(function () {
    if (!products.length) return;

    var _products$slice = products.slice(-1),
        _products$slice2 = (0,slicedToArray/* default */.Z)(_products$slice, 1),
        lastElement = _products$slice2[0];

    setLastEl(lastElement.id);
  }, [products]);
  (0,react.useEffect)(function () {
    if (scrollRef.current && products.length && scrollPosition && search) {
      var timeout = setTimeout(function () {
        scrollRef.current.scrollTop = scrollPosition;
      }, 50); // eslint-disable-next-line no-undef

      return function () {
        return clearTimeout(timeout);
      };
    }
  }, []);

  var toggleDrawerFunc = function toggleDrawerFunc() {
    if (search) {
      setScrollPosition(scrollRef.current.scrollTop);
    }

    toggleDrawer();
  };

  if (productError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_500["default"], {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,utils.cn)("relative mt-4 grid min-h-[80vh] gap-[11px_22px] pt-16", wrapperClassName),
    ref: scrollRef,
    children: [products.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(RestorableList/* default */.Z, {
      useVirtualizer: useVirtualizer,
      children: react.Children.toArray(products.map(function (_, index) {
        var startIndex = index * 2;
        var endIndex = startIndex + 2;
        var rowProducts = products.slice(startIndex, endIndex);
        if (!rowProducts.length) return null;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,utils.cn)("grid grid-cols-2 gap-4", search && "px-6"),
          children: react.Children.toArray(rowProducts.map(function (product) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: lastEl === product.id ? ref : null,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
                cohort: store.cohort.includes(2) ? store.cohort : null,
                product: product,
                top: index === 0,
                toggleDrawer: toggleDrawerFunc,
                search: search
              })
            });
          }))
        });
      }))
    }) : (!isProductsLoading || !isFetchingNextPage) && /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyStore/* default */.Z, {
      store: store,
      search: search,
      searchQuery: searchQuery
    }), (isFetchingNextPage || isProductsLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,utils.cn)("grid grid-cols-2 gap-4", search && "px-6"),
      children: Array(6).fill(0).map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
            imageClass: "rounded-lg object-cover max-w-[none] w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]",
            titleClass: "h-4 w-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)]",
            descriptionClass: "h-4 w-[calc((100vw/2)-150px)] md:w-[calc((520px/2)-150px)]",
            containerClass: "flex justify-start items-start flex-col max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]"
          }, i)
        }, i);
      })
    })]
  });
};

/* harmony default export */ var components_ProductListing = (ProductListing);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.mjs
var io5 = __webpack_require__(447);
// EXTERNAL MODULE: ./node_modules/react-loader-spinner/dist/index.js
var dist = __webpack_require__(1607);
;// CONCATENATED MODULE: ./components/Navbar/SearchInput.jsx








var SearchInput = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Search by product name" : _ref$placeholder,
      className = _ref.className,
      isLoading = _ref.isLoading;

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      searchQuery: state.searchQuery,
      setSearchQuery: state.setSearchQuery
    };
  }),
      searchQuery = _useStore.searchQuery,
      setSearchQuery = _useStore.setSearchQuery;

  var searchRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return {
      getValue: function getValue() {
        return searchQuery;
      },
      focus: function focus() {
        return searchRef.current.focus();
      }
    };
  });

  var handleClear = function handleClear() {
    setSearchQuery("");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,utils.cn)("relative", className),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-muted-foreground absolute left-5 top-1/2 -translate-y-1/2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(io5/* IoSearch */.eaK, {
          size: 24,
          className: "text-primary"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "text",
        value: searchQuery,
        onChange: function onChange(e) {
          return setSearchQuery(e.target.value);
        },
        placeholder: placeholder,
        className: "h-12 w-full rounded-full bg-secondary bg-opacity-10 pl-12 pr-9 text-fontBackground placeholder-fontBackground placeholder:opacity-70 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary",
        ref: searchRef,
        maxLength: 40
      }), (searchQuery.length > 0 || isLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute right-3 top-1/2 flex -translate-y-1/2 items-center",
        children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
          type: "Oval",
          color: "var(--color-primary)",
          height: 30,
          width: 30
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: handleClear,
          "aria-label": "Clear search",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(io/* IoMdClose */.QAE, {
            size: 24,
            className: "text-primary"
          })
        })
      })]
    })
  });
});
;// CONCATENATED MODULE: ./components/Navbar/SearchSidebar.jsx










var SearchSidebar = function SearchSidebar(_ref) {
  var isOpen = _ref.isOpen,
      toggleDrawer = _ref.toggleDrawer,
      store = _ref.store,
      searchRef = _ref.searchRef;

  var _useState = (0,react.useState)(""),
      rawSearchValue = _useState[0],
      setRawSearchValue = _useState[1];

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      setShouldSearchReopen: state.setShouldSearchReopen
    };
  }),
      setShouldSearchReopen = _useStore.setShouldSearchReopen;

  (0,react.useEffect)(function () {
    // eslint-disable-next-line no-undef
    var interval = setInterval(function () {
      if (searchRef.current) {
        setRawSearchValue(searchRef.current.getValue());
      }
    }, 200); // eslint-disable-next-line no-undef

    return function () {
      return clearInterval(interval);
    };
  }, []);
  var debouncedSearch = hooks_useDebounce(rawSearchValue, 500);
  var storeProductsQueryProps = useSearchProducts(store.id, "all", debouncedSearch);
  var isFetching = storeProductsQueryProps.isFetching,
      scrollPosition = storeProductsQueryProps.scrollPosition,
      setScrollPosition = storeProductsQueryProps.setScrollPosition;
  (0,react.useEffect)(function () {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return function () {
      document.body.style.overflow = "";
    };
  }, [isOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("aside", {
    className: "fixed right-0 top-0 z-[101] h-screen w-screen transform overflow-y-auto bg-background text-fontBackground shadow-lg transition-transform ".concat(isOpen ? "translate-x-0" : "translate-x-full"),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col py-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center px-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-xl font-bold text-primary",
          children: "Search"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "absolute right-5 top-8 z-50 inline-block w-fit border-0 bg-transparent",
          onClick: function onClick() {
            toggleDrawer();
            setShouldSearchReopen(null);
          },
          "aria-label": "Close Search Sidebar",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(io/* IoMdClose */.QAE, {
            size: 30,
            className: "text-primary"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-5 px-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchInput, {
          isLoading: isFetching,
          ref: searchRef
        })
      }), debouncedSearch.length > 2 && /*#__PURE__*/(0,jsx_runtime.jsx)(components_ProductListing, {
        store: store,
        storeProductsQueryProps: storeProductsQueryProps,
        search: true,
        wrapperClassName: "pt-2 overflow-x-hidden overflow-y-auto hide-scrollbar h-[80vh] md:w-[550px] md:mx-auto",
        useVirtualizer: true,
        searchQuery: debouncedSearch,
        toggleDrawer: toggleDrawer,
        setScrollPosition: setScrollPosition,
        scrollPosition: scrollPosition
      })]
    })
  });
};

/* harmony default export */ var Navbar_SearchSidebar = (SearchSidebar);

/***/ })

}]);